import React, {FC} from 'react';
import styles from './Chat.module.scss';
import {Helmet} from "react-helmet";

interface ChatProps {
}

const Chat: FC<ChatProps> = () => (
    <div className={styles.Chat}>

        <Helmet>
            <meta charSet="utf-8"/>
            <title>Chat</title>
        </Helmet>

        <div className="standard-margin">
            <h1><abbr title="electronic Technical Information Center">eTIC</abbr> Chat</h1>
            <hr></hr>
            <div className="quicklink">Quicklink:&nbsp;<a
                href="https://teams.microsoft.com/l/team/19%3a34e72619e8fd4dd19b7327a3d0ade5d2%40thread.skype/conversations?groupId=a76d698b-c933-4449-8211-b40058fe083d&amp;tenantId=0693b5ba-4b18-4d7b-9341-f32f400a5494"
                target="_blank" id="anch_36">Returning <abbr>e</abbr>TIC<abbr>2</abbr> Users</a></div>
            <hr></hr>
            <p className={styles.question}>Q. What is the advantage of using the Microsoft Teams environment to contact
                TIC?</p>
            <p className={styles.answer}>A. One of the best reasons for using Microsoft Teams is how easy it is to
                communicate with us. You can have a public
                conversation with our team members, or a private conversation in the background.</p>
            <p className={styles.question}>Q. How do I get started using Teams <abbr>e</abbr>TIC Web Chat?</p>
            <p className={styles.answer}>A. To set up 'Teams Chat' for the first time:</p>
            <ol className={styles.ol}>


                <li>Join the <a
                    href="https://teams.microsoft.com/l/team/19%3a34e72619e8fd4dd19b7327a3d0ade5d2%40thread.skype/conversations?groupId=a76d698b-c933-4449-8211-b40058fe083d&amp;tenantId=0693b5ba-4b18-4d7b-9341-f32f400a5494"
                    target="_blank" id="anch_39"><abbr>e</abbr>TIC Web Chat Team</a> by entering code cxxv90a
                </li>
            </ol>
            <p className={styles.question}>Q. How do I know if I'm a member of the <abbr>e</abbr>TIC Web Chat team?</p>
            <p className={styles.answer}>A. When you first join — the word 'joined' will appear.
                Consequently, <abbr>e</abbr>TIC Web Chat will appear in the 'Teams' panel with the other teams you
                have access.</p>
            <p className={styles.question}>Q. How do I start a conversation?</p>
            <p className={styles.answer}>A. The conversation can be:</p>
            <ul>
                <li><b><a id="publicConversation"></a>Public</b><span
                    className="Extra">: </span><abbr>e</abbr>TIC Web Chat is a 'General' channel. You can see
                    other conversations or start a new one.
                </li>
                <li><b><a id="privateConversation"></a>Private</b><span
                    className="Extra">: </span>Use the 'Chat' tile functionality. Access your contacts to start a
                    conversation with a single person or a group. Use the new chat button (top navigation) to add
                    people to the conversation.
                </li>
            </ul>
            <p className={styles.question}>Q. When I start a conversation, how will I know when the conversation is
                continuing/has a reply?</p>
            <p className={styles.answer}>A. A notification icon will appear when you should be aware of the
                conversation's activity.</p>
            <p className={styles.question}>Q. What if I want to cancel my membership to the <abbr>e</abbr>TIC Web Chat
                team?</p>
            <p className={styles.answer}>A. If you want to leave the team at any time, go to the ellipses on the right
                of
                the team's name and select leave the team. You will need to confirm your choice.</p>

        </div>
        <br></br> <br></br> <br></br>
    </div>
);

export default Chat;
